'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../external/classnames/index.js');
var FooterContact = require('./FooterContact/FooterContact.js');
var FooterLinks = require('./FooterLinks/FooterLinks.js');
var FooterLegal = require('./FooterLegal/FooterLegal.js');
var FooterCopyright = require('./FooterCopyright/FooterCopyright.js');
var FooterSponsor = require('./FooterSponsor/FooterSponsor.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Footer = function Footer(_ref) {
  var className = _ref.className,
    footerData = _ref.footerData;
  var column_one_header = footerData.column_one_header,
    column_two_header = footerData.column_two_header,
    column_three_header = footerData.column_three_header,
    column_one_links = footerData.column_one_links,
    column_two_links = footerData.column_two_links,
    column_three_links = footerData.column_three_links,
    legal_links = footerData.legal_links;
  var classes = index.default('lanl-footer', className);
  return /*#__PURE__*/React__default.default.createElement("footer", null, /*#__PURE__*/React__default.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__default.default.createElement(FooterContact.FooterContact, null), /*#__PURE__*/React__default.default.createElement(FooterLinks.FooterLinks, {
    header: column_one_header,
    data: column_one_links
  }), /*#__PURE__*/React__default.default.createElement(FooterLinks.FooterLinks, {
    header: column_two_header,
    data: column_two_links
  }), /*#__PURE__*/React__default.default.createElement(FooterLinks.FooterLinks, {
    header: column_three_header,
    data: column_three_links
  }), /*#__PURE__*/React__default.default.createElement(FooterSponsor.FooterSponsor, {
    header: 'DOE'
  }), /*#__PURE__*/React__default.default.createElement(FooterLegal.FooterLegal, {
    data: legal_links
  }), /*#__PURE__*/React__default.default.createElement(FooterCopyright.FooterCopyright, null)));
};
Footer.propTypes = {
  footerData: PropTypes__default.default.object.isRequired,
  className: PropTypes__default.default.string
};

exports.Footer = Footer;
exports.default = Footer;
//# sourceMappingURL=Footer.js.map
